const siteIds = [
"M15005",
"M15008",
"M15011",
"M15014",
"M15015",
"M15019",
"M15024",
"M15027",
"M15109",
"M15115",
"M15117",
"M15118",
"M15119",
"M15124",
"M15197",
"M15200",
"M15201",
"M15202",
"M15216",
"M15578",
"M15727",
"M15728",
"M15729",
"M15731",
"M15746",
"M15754",
"M15763",
"M15779",
"M15781",
"M15782",
"M15787",
"M15970",
"M15972",
"M15998",
"M16012",
"M16020",
"M16483",
"M16503",
"M16511",
"M16512",
"M16525",
"M16527",
"M16528",
"M16542",
"M16627",
"M16636",
"M16554",
"M16557",
"M16558",
"M16565",
"M16603",
"M16612",
"M16641",
"M16654",
"M16655",
"M16658",
"M16671",
"M16672",
"M16698",
"M16703",
"M16704",
"M16710",
"M16723",
"M16731",
"M16746",
"M16808",
"M16900",
"M16878",
"M16932",
"M16937",
"M16938",
"M16953",
"M16970",
"M16984",
"M17004",
"M17005",
"M17007",
"M17084",
"M17120",
"M17125",
"M17134",
"M17148",
"M17157",
"M17184",
"M17221",
"M17257",
"M17291",
"M17314",
"M17347",
"M17363",
"M17630",
"M17652",
"M17658",
"M17727",
"M17731",
"M17733",
"M17674",
"M17691",
"M17755",
"M17775",
"M17778",
"M17780",
"M17810",
"M17828",
"M17834",
"M17835",
"M17838",
"M17855",
"M17880",
"M17883",
"M17897",
"M17902",
"M17910",
"M17913",
"M17917",
"M17927",
"M18126",
"M17932",
"M17933",
"M17934",
"M17935",
"M17940",
"M17956",
"M17962",
"M17984",
"M18011",
"M18020",
"M18053",
"M18060",
"M18073",
"M18077",
"M18227",
"M18241",
"M18108",
"M18259",
"M19674",
"M19700",
"M19704",
"M19715",
"M19718",
"M19720",
"M19722",
"M19741",
"M19742",
"M19749",
"M19750",
"M19757",
"M19759",
"M19762",
"M19780",
"M19785",
"M19799",
"M19802",
"M19803",
"M19808",
"M19810",
"M19848",
"M19854",
"M19858",
"M19862",
"M19864",
"M19871",
"M19888",
"M19892",
"M19898",
"M19913",
"M19916",
"M19942",
"M19967",
"M19982",
"M19983",
"M19986",
"M19994",
"M19995",
"M20000",
"M20043",
"M20047",
"M20052",
"M18289",
"M18302",
"M18304",
"M18352",
"M18354",
"M18355",
"M18372",
"M18382",
"M18383",
"M18387",
"M18393",
"M18394",
"M18471",
"M18498",
"M18518",
"M18541",
"M18698",
"M18715",
"M18809",
"M18810",
"M18812",
"M18816",
"M18822",
"M18844",
"M18847",
"M18857",
"M18870",
"M18871",
"M18880",
"M18892",
"M18903",
"M18906",
"M18911",
"M18925",
"M18948",
"M19597",
"M19605",
"M19610",
"M19615",
"M19616",
"M19617",
"M19630",
"M19633",
"M19661",
"M189",
"M192",
"M193",
"M196",
"M197",
"M202",
"M204",
"M205",
"M206",
"M697",
"M717",
"M720",
"M723",
"M727",
"M728",
"M729",
"M732",
"M739",
"M740",
"M744",
"M764",
"M765",
"M766",
"M776",
"M778",
"M794",
"M796",
"M798",
"M800",
"M813",
"M815",
"M816",
"M817",
"M818",
"M820",
"M821",
"M824",
"M825",
"M826",
"M832",
"M840",
"M845",
"M849",
"M855",
"M857",
"M878",
"M892",
"M901",
"M902",
"M909",
"M914",
"M917",
"M923",
"M924",
"M934",
"M937",
"M975",
"M978",
"M984",
"M985",
"M987",
"M988",
"M989",
"M991",
"M992",
"M993",
"M996",
"M1001",
"M1002",
"M1006",
"M1007",
"M1008",
"M1009",
"M1015",
"M1017",
"M1018",
"M1019",
"M1020",
"M1021",
"M1025",
"M1028",
"M1031",
"M1033",
"M1034",
"M1054",
"M1058",
"M1061",
"M1062",
"M1063",
"M1064",
"M1065",
"M1071",
"M1072",
"M1073",
"M1076",
"M1082",
"M1099",
"M1130",
"M1131",
"M1136",
"M1138",
"M1148",
"M1152",
"M1156",
"M1165",
"M1170",
"M1176",
"M1524",
"M1644",
"M1655",
"M1664",
"M1665",
"M1670",
"M1673",
"M1683",
"M1965",
"M1973",
"M1977",
"M1978",
"M1985",
"M1986",
"M1987",
"M1989",
"M2002",
"M2029",
"M2117",
"M2146",
"M2147",
"M2152",
"M2163",
"M2219",
"M7858",
"M8965",
"M9090",
"M9097",
"M9251",
"M9528",
"M9532",
"M9533",
"M10182",
"M10787",
"M10970",
"M11557",
"M11567",
"M11595",
"M11863",
"M11865",
"M11866",
"M11867",
"M11870",
"M12149",
"M12491",
"M12493",
"M12495",
"M12497",
"M12806",
"M12810",
"M12811",
"M12815",
"M12818",
"M12832",
"M12840",
"M12845",
"M12847",
"M13049",
"M13044",
"M13046",
"M13052",
"M13055",
"M13057",
"M13472",
"M13603",
"M14216",
"M14218",
"M14224",
"M14229",
"M14230",
"M14231",
"M14232",
"M14240",
"M14241",
"M14244",
"M14449",
"M14450",
"M14451",
"M14520",
"M14771",
"M14952",
"M14953",
"M14963",
"M14971",
"M14977",
"M14983",
"M14987",
"M14994",
"M14995",
"M20065",
"M20073",
"M20074",
"M20079",
"M20086",
"M20087",
"M20096",
"M20098",
"M20101",
"M20110",
"M20121",
"M20131",
"M20141",
"M20148",
"M20152",
"M20154",
"M20158",
"M20162",
"M20172",
"M20174",
"M20177",
"M20185",
"M20184",
"M20193",
"M20192",
"M20202",
"M20224",
"M20232",
"M20234",
"M20240",
"M20245",
"M20247",
"M20251",
"M20252",
"M20257",
"M20263",
"M20265",
"M20269",
"M20273",
"M20286",
"M20288",
"M20303",
"M20304",
"M20382",
"M20394",
"M20395",
"M20396",
"M20401",
"M20404",
"M20406",
"M20405",
"M20407",
"M20410",
"M20412",
"M20414",
"M20415",
"M20419",
"M20428",
"M20432",
"M20436",
"M20456",
"M20497",
"M20514",
"M20515",
"M20532",
"M20539",
"M20551",
"M20579",
"M20598",
"M20606",
"M20607",
"M20630",
"M20633",
"M20635",
"M20647",
"M20648",
"T10000"
]

if (window.BSS_BCP_V2?.r4q?.logics?.length) {
    // BSS's current config keeps the fields in logics[0].formFields, so this finds nothing and the Site ID
    // list isn't enforced (same as live). Switch the path to `.formFields` to turn the check back on.
    const siteField = BSS_BCP_V2.r4q.logics[0].form?.formFields.find((item) => item.label === "Site ID");
    if (siteField) siteField.pattern = `^(${siteIds.join("|")})$`;

    document.addEventListener("DOMContentLoaded", function () {
        // BSS already drops logics the customer doesn't qualify for, so only the product needs checking.
        if (
            BSS_BCP_V2.findProductRule(BSS_BCP_V2.r4q.logics[0].productRules || [], BSS_BCP_V2.product) &&
            Object.keys(BSS_BCP_V2.r4q.customData || {}).length
        ) {
            const customData = BSS_BCP_V2.r4q.customData;
            document.querySelectorAll(".bcp-r4q-customized-button").forEach(function (quoteButton) {
                const customForm = quoteButton.closest("form[action='/cart/add']");
                if (!customForm) return;
                quoteButton.style.display = "block";
                quoteButton.innerHTML = BSS_BCP_V2.r4q.translation.quote_button_content || "Add to quote";
                quoteButton.addEventListener("click", function () {
                    const r4qFormData = JSON.parse(localStorage.getItem("r4qFormData") || "{}");
                    const r4qVariants = JSON.parse(localStorage.getItem("r4qVariants") || "[]");

                    Array.from(new FormData(customForm).entries()).forEach(([key, value]) => {
                        if (key === "quantity") {
                            const quantity = Number(value) || 1;
                            const product = BSS_BCP_V2.r4q.productMap.get(BSS_BCP_V2.product.id);
                            const variantId = new URLSearchParams(window.location.search).get("variant") || product.variants[0].id;

                            if (!product?.variants?.[0]) return;

                            const variantIndex = r4qVariants.findIndex((item) => {
                                return (item.productId === product.id) && (item.variantId === variantId);
                            });

                            if (variantIndex >= 0) {
                                r4qVariants[variantIndex].quantity += quantity;
                            } else {
                                r4qVariants.push({ productId: product.id, variantId, quantity });
                            }
                        } else if (/properties\[Attendees ([0-9]+) - Email\]/.test(key) && value) {
                            r4qFormData.email = value;
                        } else if (/properties\[Attendees ([0-9]+) - Full Name\]/.test(key) && value) {
                            r4qFormData.firstName = value;
                        } else if (/properties\[Attendees ([0-9]+) - Models\]/.test(key) && value && customData[value]?.id) {
                            const product = customData[value];
                            const variantIndex = r4qVariants.findIndex((item) => {
                                return (item.productId === product.id) && (item.variantId === product.variantId);
                            });

                            if (variantIndex >= 0) {
                                r4qVariants[variantIndex].quantity += 1;
                            } else {
                                r4qVariants.push({ productId: product.id, variantId: product.variantId, quantity: 1 });
                            }
                        }
                    });

                    localStorage.setItem("r4qFormData", JSON.stringify(r4qFormData));
                    localStorage.setItem("r4qVariants", JSON.stringify(r4qVariants));
                    document.body.dispatchEvent(new CustomEvent("bcpR4q:addItemsSuccess", { bubbles: true, composed: true, detail: {} }))
                });
            });
        }
    })
}